import { render, staticRenderFns } from "./ExitButton.vue?vue&type=template&id=113eba88&scoped=true&"
import script from "./ExitButton.vue?vue&type=script&lang=js&"
export * from "./ExitButton.vue?vue&type=script&lang=js&"
import style0 from "./ExitButton.vue?vue&type=style&index=0&id=113eba88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113eba88",
  null
  
)

export default component.exports